import { useEffect } from 'react';
import { Card, Col, Container, Image, Row } from 'react-bootstrap';
import logo from '../../components/Nav/assets/Sidebar_Logo_Open.png';

const PolicyAndCookies = ({ data, setShowFull, setShowSmallMenu }) => {
  useEffect(() => {
    setShowFull(false);
    setShowSmallMenu(false);

    return () => {
      setShowSmallMenu(true);
    };
  }, [setShowFull, setShowSmallMenu]);

  return (
    <Container fluid className="h-100 py-4 pb-3">
      <Row className="justify-content-center h-100">
        <Col xs={12} lg={10} className="d-flex flex-column gap-4 h-100 min-h-0">
          {/* Header (non-scroll) */}
          <div className="d-flex flex-column flex-md-row align-items-center gap-3 flex-shrink-0">
            <Image src={logo} alt="Logo" fluid width={200} />
            <div className="text-center text-md-start">
              <h1 className="mb-2">Privacy &amp; Cookie Policy</h1>
              <p className="mb-0">
                This Privacy &amp; Cookie Policy was last modified on {data.date}
              </p>
            </div>
          </div>
          {/* Content (scrollable) */}
          <Card className="bg-transparent border-0 shadow-sm flex-grow-1 min-h-0 px-3 px-md-4">
            <Card.Body className="bg-primary-shadow text-start p-4 p-md-5 rounded-3 overflow-auto">
              <p className="fs-6 mb-0">{data.page}</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PolicyAndCookies;
